import {
    MEDIA_PATH_PREFIX_ENCODED,
    MEDIA_PATH_SUFFIX_ENCODED,
} from '@/presentation/constants/contentConstants';

/**
 * Convert a Firestore-stored, URL-encoded media `path`
 * (`media%2F<userId>%2F<mediaId>%2F`) to the route segment used by
 * `/content/@…` URLs. Strips the constant `media%2F` prefix and trailing
 * `%2F` (re-applied by `decodeMediaPathFromRoute`) so the address bar stays
 * short, then percent-encodes what remains so the `%2F` separators survive
 * the route param decode.
 *
 * Pair with `decodeMediaPathFromRoute` — both must move together.
 */
export const encodeMediaPathForRoute = (relativePath: string): string => {
    let trimmed = relativePath;
    if (trimmed.startsWith(MEDIA_PATH_PREFIX_ENCODED)) {
        trimmed = trimmed.substring(MEDIA_PATH_PREFIX_ENCODED.length);
    }
    if (trimmed.endsWith(MEDIA_PATH_SUFFIX_ENCODED)) {
        trimmed = trimmed.substring(0, trimmed.length - MEDIA_PATH_SUFFIX_ENCODED.length);
    }
    return encodeURIComponent(trimmed);
};

/**
 * Reverse of `encodeMediaPathForRoute`. Given the route param value (after
 * react-router has stripped the leading `@` and decoded one layer), rebuild
 * the exact Firestore-stored form of `path`. The inner `replace` puts back
 * the `%2F` separators that the route segment decoded into literal slashes.
 */
export const decodeMediaPathFromRoute = (routeParam: string): string => {
    return MEDIA_PATH_PREFIX_ENCODED
        + routeParam.replace(/\//g, '%2F')
        + MEDIA_PATH_SUFFIX_ENCODED;
};
